import { Can } from 'components/Can';
import { SpecializeReviewDetail } from 'features/SpecializeReview/pages';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function SpecializeReviewDetailPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <Can do="read" on="specialize_review">
          <SpecializeReviewDetail />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}

export default SpecializeReviewDetailPage;
